import ThumbnailCard from '@/components/ThumbnailCard'

interface SceneThumbnailProps {
  preview?: string
  selected?: boolean
  isActive?: boolean
  isLoading?: boolean
  isDisabled?: boolean
  baseSize: {
    width: number
    height: number
  }
}

const SceneThumbnail: React.FC<SceneThumbnailProps> = ({
  preview,
  selected = false,
  isActive = false,
  isLoading = false,
  isDisabled = false,
  baseSize,
}) => (
  <ThumbnailCard
    imageSrc={preview}
    selected={selected}
    isActive={isActive}
    isLoading={isLoading}
    isDisabled={isDisabled}
    size={baseSize}
    renderContent={Boolean(preview || isLoading)}
  />
)

export default SceneThumbnail
